/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Grid, Stack, SvgIcon, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import NotificationsBox from './components/ManageNotificationsBox';
import useNswagClient from '../../hooks/api/useNswagClient';
import { useEffect, useState } from 'react';
import useLocalStorage from '../../hooks/useLocalStorage';
import { Notification2, SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification } from '../../app/services/api/generated';
import useLogError from '../../hooks/useLogError';
import PageArea from '../../components/shared/PageArea';
import PageTitle from '../../components/shared/PageTitle';
import { Plus } from '../../assets';
import CreateUpdateNotificationModal from './components/NotificationEditCreateModal';
import MessagesSnackbar from '../../components/shared/MessagesSnackbar';

const Notifications = () => {
  const { getAllNotifications, saveNotification } = useNswagClient();
  const theme = useTheme();
  const [notifications, setNotifications] = useState<Notification2[]>([]);
  const [selectedStore, defaultStoreValue] = useLocalStorage('selectedStore', null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [showCreateSuccessMessage, setShowCreateSuccessMessage] = useState<boolean>(false);
  const { t } = useTranslation('manageNotifications');
  const { logError } = useLogError();
  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.md}px)`);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    if (selectedStore != null) {
      setIsLoading(true);
      getAllNotifications(selectedStore.storeNumber ?? defaultStoreValue).then((result: SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification) => {
        if (result?.data) {
          setNotifications(result.data as Notification2[] ?? []);
        }
      })
        .catch((error) => {
          logError(error);
        })
        .finally(() => (setIsLoading(false)));
    }
  };

  const handleCreate = (body: Notification) => {
    saveNotification(body)
      .then(() => {
        setShowCreateSuccessMessage(true);
        setTimeout(() => loadData(), 2000);
      })
      .catch((error) => logError(error));
  };

  return <PageArea>
    <Grid container>
      <Stack width='100%'
        spacing={2}
        direction={isMobile ? 'column' : 'row'}
        sx={{
          justifyContent: 'space-between',
        }}>
        <PageTitle subTitle={t('subtitle')}>{t('heading')}</PageTitle>
        <Button variant="primary"
          size="lg"
          startIcon={<SvgIcon> <Plus fill='white' /> </SvgIcon>}
          onClick={() => setShowCreateModal(true)}>
          {t('newNotification')}
        </Button>
      </Stack>

      <NotificationsBox
        notifications={notifications}
        loadData={loadData}
        isLoading={isLoading}
        onCreate={() => setShowCreateModal(true)}
      />
    </Grid>

    <CreateUpdateNotificationModal
      openModal={showCreateModal}
      onCancel={() => setShowCreateModal(false)}
      notification={undefined}
      onConfirm={(requestBody: Notification) => handleCreate(requestBody)}
    />

    <MessagesSnackbar
      open={showCreateSuccessMessage}
      onClose={() => setShowCreateSuccessMessage(false)}
      message={'Notification created successfully'}
      severity="success"
      duration={null}
    />
  </PageArea>;
};

export default Notifications;